<div class="auth-flow-subtext">
  <div class="header" i18n>{{ 'Forgot Your Password?' }}</div>
  <div class="subtext" i18n>
    {{
      'Enter your email address below to receive instructions for resetting your password and regaining access to your account.'
    }}
  </div>
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="email" class="form-input-label" i18n>Email</label>
    <app-email-input
      formControlName="email"
      controlId="email"
      (keydown.enter)="submit()"
      [error]="formSubmitted && formGroup.controls.email.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.email.invalid"
      [errors]="formGroup.controls.email.errors" />
  </div>
</form>

<div class="reset-button-container">
  <app-primary-button
    class="action-button"
    [width]="'100%'"
    [disabled]="(viewModel.emailSent$ | async) ?? false"
    (buttonClicked)="submit()">
    {{ (viewModel.emailSent$ | async) ? emailSentText : resetPasswordText }}
  </app-primary-button>

  <button class="paddingless-text-button" i18n (click)="backToLogin()">
    {{ 'Back to Login' }}
  </button>

  <div class="subtext pt-16px" *ngIf="viewModel.emailSent$ | async">
    <ng-container i18n>The email has been sent to the address above with a link to set a new password.</ng-container>
  </div>
</div>
